import React from 'react';
import { useTheme, ITheme } from 'src/theme';
import { styled } from '@linaria/react';
const Container = styled.div<StyledProps>`
  padding: 32px 20px 30px 20px;
  background-color: ${props => props.theme?.colors.grey[600]};
  border-top: ${props => props.hasBorderTop ? `2px solid ${props.theme?.colors.secondary}` : ''};
  box-sizing: border-box;
  position: relative;
  visibility: ${props => props.visable ? 'visible' : 'hidden'};
`

const IconTriangle = styled.div<{color: string, size: number, top: number, left: number}>`
  width: 0;
  height: 0;
  border-left: ${props => props.size}px solid transparent;
  border-right: ${props => props.size}px solid transparent;
  border-top: ${props => props.size}px solid ${props => props.color};
  position: absolute;
  top: ${props => props.top}px;
  left: ${props => props.left}px;;
  margin-left: 50%;
  transform: translateX(-50%);  
`

const SegmentContent = styled.div<StyledProps>`
  display: block;
  box-sizing: border-box; 
  -webkit-box-sizing: border-box;
`


interface StyledProps {
  theme? : ITheme;
  hasBorderTop?: boolean | undefined;
  visable?: boolean;
}

export interface SegmentProps {
  id?: string | undefined;
  className?: string | undefined;
  theme? : ITheme;
  children?: React.ReactNode;
  hasBorderTop?: boolean;
  visable: boolean
}

function Segment({ id, className, children, hasBorderTop, visable }: SegmentProps) {
  const theme = useTheme();
  return <Container visable={visable} id={id} className={className} theme={theme} hasBorderTop={hasBorderTop}>
    { hasBorderTop && <React.Fragment>
      <IconTriangle size={10} color={theme.colors.secondary} top={-2} left={0}/>
      <IconTriangle size={8} color={theme.colors.white} top={-3} left={0}/>
    </React.Fragment> }
   
    <SegmentContent theme={theme} className="aviva-segment-content">
      {children} 
    </SegmentContent>
     
  </Container>;
};


Segment.defaultProps = {
  hasBorderTop: false,
  visable: true
}

export default Segment;
